export enum Page {
  GettingStarted,
  SelectAttachment,
}
